import React, { useState, useEffect, Fragment } from "react";
import {
  Nav,
  NavbarToggler,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useIdleTimer } from "react-idle-timer";
import MediaQuery from "react-responsive";
import { EnvironmentSign } from "bx-react-ui";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";
import { Prompt } from "react-router-dom";

import { getUserContext, getAuth, getSession } from "../../../reducers/selectors";
import { UserSelector } from "../../UserSelector/UserSelector";
import { signOut } from "../../../actions/auth";
import menuLine from "../../../../public/svg/menu.svg";
import GenericButton from "../../UI/Button/Button";
import { Help } from "../../Help/Help";

import style from "./Header.scss";
import { useInterval } from "bx-react-ui/src/utils/hooks";
import { getPersonInfo } from "../../../services/api/person";

const environmentName = window.___APP_CONFIG___.ENV_NAME ? window.___APP_CONFIG___.ENV_NAME : "TESTING";

export const Header = ({ AccountJSON, actions, title }) => {
  const userSession = getSession();
  const username = userSession ? userSession.Username : null;

  const isProdEnv = userSession ? userSession.IsProductionEnv : true;
  const isTestingUser = userSession && userSession.IsTestingUser ? userSession.IsTestingUser : false;

  const showEnvironmentSign = !isProdEnv || isTestingUser;
  const environmentSignText = isProdEnv ? "PRODUCTION" : environmentName;
  const environmentSignColor = isProdEnv ? "red" : "#34784B";
  const dispatch = useDispatch();

  const context = useSelector(getUserContext);
  const [idleTimeout, setIdleTimeout] = useState(1);
  const [showHelp, setShowHelp] = useState(false);
  const [isAppMobile, setIsAppMobile] = useState(false);

  useEffect(() => {
    if (context !== null) {
      if (Object.keys(context)) {
        setIsAppMobile(window.___APP_CONFIG___.APP_MOBILE);
        setIdleTimeout(context.session.MaxIdleSessionTime);
      }
    }
  }, [context]);

  useEffect(() => {
    setIsAppMobile(window.___APP_CONFIG___.APP_MOBILE);
  }, []);

  // Don't delete - it controls the idle timer to logout session automatically
  const logoutTimer = useIdleTimer({
    timeout: idleTimeout * 60 * 1000,
    crossTab: true,
    syncTimers: 200,
    name: "logout-timer",
    onIdle: () => {
      dispatch(signOut());
      window.location.reload();
    },
  });

  useInterval(() => {
    if (isAppMobile) {
      logoutTimer.activate();
      getPersonInfo();
    }
  }, [idleTimeout * 60 * 1000 - 5000]);

  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  };

  const toggleShowHelp = () => {
    setShowHelp((stateHelp) => !stateHelp);
  };

  return (
    <header
      className={!isAppMobile ? `${style.appHeader} app-header navbar` : "hideElement"}
      style={{ margin: "0 !important" }}
    >
      <span className={style.hambMenuLogo}>
        <Fragment>
          <NavbarToggler
            className={`${style.navToggler} d-md-down-none`}
            onClick={(e) => {
              mobileSidebarToggle(e);
            }}
          >
            <img className={style.hambIcon} src={menuLine} alt="hamburger menu" />
          </NavbarToggler>
        </Fragment>
      </span>
      <img className={style.logo} src="./svg/SideBarIcons/full-logo-home-white.svg" alt="Logo" />
      {/* <p className={style.dummyDiv}></p> */}
      <MediaQuery minWidth={576}>
        <Label className={style.headerTitle}>{title}</Label>
        <Nav className="d-md-down-none" navbar>
          <GenericButton
            label={"Ayuda"}
            // icon={"fa fa-phone mr-3"}
            rounded
            padding={"12px 60px"}
            handleClick={toggleShowHelp}
            iconSvg={[{ width: "20px", item: "../../svg/SideBarIcons/phone.svg" }]}
          ></GenericButton>
          {/* <UserSelector isInNavbar className={style.userSelector} /> */}
        </Nav>
        {showEnvironmentSign && <EnvironmentSign text={environmentSignText} color={environmentSignColor} />}
        <hr style={{ width: "100%", marginBottom: "0px", paddingBottom: "0px" }}></hr>
      </MediaQuery>
      <Prompt
        when={showHelp}
        message={(location) => {
          // Ejecutar la función personalizada antes de la navegación hacia atrás
          toggleShowHelp();
          // No permitir la navegación hacia atrás
          return false;
        }}
      />
      {showHelp && <Help toggleHelp={toggleShowHelp} />}
    </header>
  );
};

const List = ({ items, loading }) => {
  const [open, setOpen] = useState(false);

  const toggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const eventsCounter = items ? items.length : "-";

  return [
    <Dropdown nav isOpen={open} toggle={toggle} key={`event-alert-list`}>
      <DropdownToggle nav>
        <span>
          <i className="icon-bell"></i>
          <Badge pill color="danger">
            {eventsCounter}
          </Badge>
        </span>
      </DropdownToggle>
      <DropdownMenu right>
        <div className={style.container}>
          <DropdownItem header tag="div" className="text-center">
            <strong>Notificaciones</strong>
          </DropdownItem>
          {loading ? (
            <CircularProgress sm />
          ) : (
            items && items.length == 0 && <h6 className={style.empty}>No hay notificaciones</h6>
          )}
          {items &&
            items.map((item, i) =>
              i < 5 ? (
                <span>
                  {item}
                  <hr />
                </span>
              ) : null
            )}
        </div>
        <DropdownItem tag={Link} to="notifications" className={`view-more ${style.more}`}>
          Ver todas las notificaciones
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>,
  ];
};
